<div class="grid">
    <div class="
            col-12
            sm:col-12
            md:col-3
            lg:col-3
            xl:col-3
            text-center
            ">
            <a [routerLink]="['/product-catalog/detail', product.product.id, product.product.category]">
                <img [src]="product.product.image" alt="" style="max-width: 100%; max-height: 9rem;">
            </a>

    </div>
    <div class="
            col-12
            sm:col-12
            md:col-8
            lg:col-8
            xl:col-8
            ">
            <div class="grid">
                <div class="
                    col-12
                    sm:col-12
                    md:col-4
                    lg:col-4
                    xl:col-4
                    ">
                    <p>{{ product.product.productName }}</p>
                    <p>Color: {{ product.product.colorValue }}</p>
                    <p>Medida: {{ product.product.measurementSystemDetailValue }}</p>
                    <p>{{ showPrice() | currency }}</p>
                </div>
                <div class="
                    col-12
                    sm:col-12
                    md:col-4
                    lg:col-4
                    xl:col-4
                    ">
                    <div class="p-fluid">
                        <div class="p-field">
                            <custom-input-number-control [(ngValue)]="product.cant" (ngValueChange)="changeCant($event)" [disabled]="true"></custom-input-number-control >
                        </div>
                    </div>
                </div>
                <div class="
                    col-12
                    sm:col-12
                    md:col-4
                    lg:col-4
                    xl:col-4
                    text-right
                    ">
                    <p>{{ (product.cant * showPrice()) | currency }}</p>
                </div>
            </div>

    </div>

</div>
<hr style="margin-bottom: 15px;">
